<template>
<div>
    <!-- {{ defaultFiles }} -->
    <VueFileAgent ref="vueFileAgent" :theme="'grid'" :multiple="true" :deletable="true" :meta="false" :compact="compact" :sortable="sortable" :accept="'image/*'" :maxSize="'1MB'" :maxFiles="maxFiles" :helpText="'이미지 추가'" :errorText="{
      type: 'Invalid file type. Only images or zip Allowed',
      size: ' ',
    }" @sort="moveFile($event)" @delete="fileDeleted($event)" @select="filesSelected($event)" v-model="filesData">
    </VueFileAgent>
    <!-- {{ filesData }} -->
</div>
</template>

<script>
import api from "../../constants/api";
import Axios from "axios";
import {
    mapGetters
} from "vuex";
import Compressor from "compressorjs";

const {
    BlobServiceClient,
    ContainerClient
} = require('@azure/storage-blob');

export default {
    props: ['sortable', 'compact', 'maxFiles', 'defaultFiles', 'container', 'Reflect', ],

    data: function () {
        return {
            isLoad: false,
            filesData: this.defaultFiles ? this.defaultFiles : [],
            uploadHeaders: {
                'X-Test-Header': 'vue-file-agent'
            },
            thisclick: false,
            removeImg: null,
        };
    },
    watch: {
        defaultFiles(val) {
            // console.log(val)
            if (val === null) {
                this.filesData = [];
            }
        },
        Reflect(val) {
            // console.log(val)
            if (val !== null) {
                this.filesData = val;
            }
        },
        filesData(val) {
            this.removeImg = val;
        },
    },
    computed: {
        ...mapGetters(['currentUser', 'siteName']),
    },

    methods: {
        parentImgCopy(val){
            this.filesData = val;
        },
        parantRemove: function (val, fd) { // 부모에서 삭제할 url 보내줌

            let findss = this.filesData.filter(function (item) {
                let uurrll = '';
                if (item.azureUrl) {
                    uurrll = item.azureUrl
                } else {
                    uurrll = item.url
                }
                return uurrll !== val;
            });
            this.filesData = findss;
            // console.log(this.filesData);
        },
        filesSelected: function (filesDataNewlySelected) {

            let compressFilePromises = [];
            for (const fileSelectedData of filesDataNewlySelected) {
                compressFilePromises.push(this.compressImage(fileSelectedData.file));
            }

            const vm = this;

            let reqURL = api.changeAPI(vm.siteName, api.basicURL + api.user.azureSas);
            let params = {
                type: vm.container
            }

            Promise.all(compressFilePromises).then(values => {
                let fileListToUpload = values;

                // console.log("fileListToUpload", fileListToUpload);

                vm.$http.post(reqURL, params, {
                    headers: {
                        'Authorization': `Bearer ${vm.currentUser.tokens.access.token}`
                    }
                }).then(res => {
                    if (res.data.code === "OK") {

                        // console.log("sas", res.data);
                        let containerUrl = res.data.data.url
                        const containerClient = new ContainerClient(containerUrl);

                        fileListToUpload.forEach(function (fileToUpload, index) {
                            // console.log("fileListToUpload.forEach", fileToUpload);

                            // const file = upload.file;
                            const now = vm.$moment(new Date()).format('YYYYMMDDHHmmss')

                            const blockBlobClient = containerClient.getBlockBlobClient(`${res.data.data.directory}/${now}` + index);

                            blockBlobClient.uploadBrowserData(fileToUpload, {
                                blockSize: 4 * 1024 * 1024, // 4MB block size
                                // concurrency: 20,
                                blobHTTPHeaders: {
                                    blobContentType: fileToUpload.type
                                }

                            }).then(success => {
                                // console.log("success", success)
                                let uploadedUrl = success._response.request.url.substring(0, success._response.request.url.indexOf("?sig="))
                                // console.log(uploadedUrl);
                                let _tmpImg = new Image();

                                _tmpImg.onload = function () {
                                    // console.log("_tmpImg.onload");
                                    if (vm.filesData.length === undefined) {
                                        vm.filesData['height'] = _tmpImg.height
                                        vm.filesData['width'] = _tmpImg.width
                                        vm.filesData['azureUrl'] = uploadedUrl
                                    } else {
                                        let _idx = (vm.filesData.length - filesDataNewlySelected.length) + index // filesData
                                        vm.filesData[_idx]['height'] = _tmpImg.height
                                        vm.filesData[_idx]['width'] = _tmpImg.width
                                        vm.filesData[_idx]['azureUrl'] = uploadedUrl
                                    }
                                    //   console.log(vm.filesData)
                                    vm.$emit('getFileData', vm.filesData);
                                    if (vm.thisclick == true) {
                                        vm.$emit('usefilesData', vm.filesData);
                                    }
                                }
                                _tmpImg.src = uploadedUrl;
                            }).catch(reason => {
                                let _idx = (vm.filesData.length - filesDataNewlySelected.length) + index
                                vm.filesData.splice(_idx, 1)
                                alert("업로드 실패")
                            })
                        });
                        // resolve('ssss')
                    } else {
                        throw 400
                    }
                }).catch(err => {
                    alert("이미지 파일을 업로드하지 못하였습니다.");
                    // reject(new Error('업로드 실패'));
                });
            }).catch((error) => {
                console.log(error);
                alert("이미지 리사이징 에러입니다.");
            });

        },
        compressImage(imageFile) {
            return new Promise((resolve, reject) => {
                let allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;

                if (!allowedExtensions.exec(imageFile.name)) {
                    resolve(imageFile);
                } else {
                    new Compressor(imageFile, {
                        maxWidth: 600,
                        quality: 0.8,
                        success(result) {
                            resolve(result)
                        },
                        error(e) {
                            reject(e)
                        },
                    });
                }
            });
        },
        moveFile: function (event) {
            //서브 이미지 파일 순서 변경시 변경된 데이터로 업데이트해줌.
            this.$emit('getFileData', this.filesData)
        },

        fileDeleted: function (fileData, idx, sub) {

            var result = [];
            var i = this.filesData.indexOf(fileData);
            this.filesData.forEach((value, index) => {
                if (index !== i) {
                    result.push(value);
                }
            });

            this.$emit('getFileData', result);
        },
        clickdelEve(idx, sub) {
        },
        deleteUploadedFile: function (fileData) {
        },

    },
};
</script>

<style scoped>

</style>
